import {RecoverFileParams} from 'domain/usecases';
import {makePostRecoverFile} from 'main/factories/usecases/private/authorizations/request/post-recover-file-factory';

export const postRecoverFile = async (params: RecoverFileParams) => {
	const response = await makePostRecoverFile().post(params);
	return response;
};
